// Component used at the begining of each Page to set page meta tags
function Meta({title}) {
    return (
        <>
            <title>{title}</title>
		    <meta charSet='utf-8' />
		    <meta name='viewport' content='width=device-width, initial-scale=1, user-scalable=no' />
        </>
    );
}

export default Meta;